const tip = "192.168.0.14";
const tid = "5fd25b12ed14200ff702f738";

export default {
  "5e7370083d8520a40c4ceaaa": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/bhashyam_mini.png",
    url_new:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/bhashyam_new.jpg",
    brand_image1:"https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/bhashyam_new.jpg",
    admin_url: "https://bhashyamadmin.onesaz.com",
    brand_image2: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/bhashyam.png",
    brand_image3: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/bhashyam_brand.png",
    title: "BHASHYAM EDUCATIONAL INSTITUTIONS",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "5ea3572fe301133d0a73e9e0": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/miity_mini.png",
    admin_url: "https://miityadmin.onesaz.com",
    title: "MIITYedu ACADEMY",
    smsHeader: "MIITYE",
    subTitle: "IIT-JEE MAIN|ADVANCED",
    PE: "1201164330565400925",
    regNo: "(Regd. No. 515/2021) ",
  },
  "5e9098aaa218252d49be5a3b": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/sr_mini.png",
    admin_url: "https://sradmin.onesaz.com",
    title: "SR EDUCATIONAL INSTITUTIONS",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "61e850055876f313e30ea1de": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/agastya_mini.png",
    admin_url: "https://agastyaadmin.onesaz.com",
    title: "AGASTYA JUNIOR COLLEGE",
    smsHeader: "AJCIIT",
    PE: "1201164330565400925",
    brand_image1:"https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/agastya_brand1.jpg",
    brand_image2:"https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/agastya_brand2.jpg ",
    brand_image3:"https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/agastya_brand3.jpg",
    brand_image4:"https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/agastya_brand4.jpg"

  },
  "640053dc178e451001e83e37": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/onesaz_mini.png",
    admin_url: "https://onesaz.com",
    title: "ONESAZ",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "5d679d49c136660a09596d85": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/onesaz_mini.png",
    admin_url: "https://onesaz.com",
    title: "ONESAZ",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0bf9": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/sriabhidakp_mini.png",
    admin_url: "https://sriabhidaadmin.onesaz.com",
    title: "SRI ABHIDA IIT JEE FOUNDATIONS - KP",
    smsHeader: "SRIAKP",
    PE: "1201164330565400925",
  },
  "645b4332b98a5dc4ce54256d": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/vinners_mini.png",
    admin_url: "https://vosadmin.onesaz.com",
    title: "VINNERS OLYMPIAD SCHOOL , NIRMAL",
    smsHeader: "VINNRO",
    PE: "1201164330565400925",
  },
  "646634c8a400ecffc1306d0d": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/turito_mini.png",
    admin_url: "https://turitoadmin.onesaz.com",
    title: "SREE SARASWATHI EDUCATIONAL SOCIETY",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "61e6489a9b609f2143aab796": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/aiitv.jpg",
    title: "SREE VENKATESWARA AIAT IIT & NEET ACADEMY",
    smsHeader: "- ",
    PE: "1201164330565400925",
  },
  "63a943927e91069155cc07da": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/edify-logo.png",
    admin_url: "https://edifyadmin.onesaz.com",
    title: "EDIFY SCHOOL",
    PE: "1201164330565400925",
  },
  "6422b982a32e9b7c5498b129": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/ligadepatil.jpg",
    admin_url: "https://lpjcadmin.onesaz.com",
    title: "LigadePatil Jr College of science",
    smsHeader: "LPJCSK",
    PE: "1201164330565400925",
  },

  "65772522ee64cfa8dc9851f2": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/SRCLG.jpg",
    admin_url: "https://srgroup.onesaz.com",
    title: "SR Educational Academy",
    smsHeader: "SREDUA",
    PE: "1501566770000051473",
  },
  "65772522ee64cfa8dc9851f2_prime": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/SRPRIME.jpg",
    admin_url: "https://srgroup.onesaz.com",
  },
  "65772522ee64cfa8dc9851f2_digi": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/SR_DIGI_LOGO1.png",
    admin_url: "https://srgroup.onesaz.com",
  },
  "65772522ee64cfa8dc9851f2_National": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/NHS-logo.png",
    admin_url: "https://srgroup.onesaz.com",
  },
  "65772522ee64cfa8dc9851f2_Dimples": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/dimples-logo.png",
    admin_url: "https://srgroup.onesaz.com",
  },
  "6617918287bfb9f18b6d32a5": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/ybrant.jpg",
    admin_url: "https://ybrantadmin.onesaz.com",
    title: "YBRANT Classes",
  },
  "6655751f14c7f8079c692091": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/SRCLG.jpg",
    admin_url: "https://srexpenses.onesaz.com",
    title: "SR Educational Academy",
    smsHeader: "SREDUA",
    PE: "1201164330565400925",
  },
  "5fd25b12ed14200ff702f738": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/tirumala_mini.png",
    admin_url: "https://tirumalaadmin.onesaz.com",
    // url_BVM: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/tirumala_bvm.png",
    // url_VSKP: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/tirumala_vskp.png",
    // url_RJY: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/tirumala_mini.png",
    title: "TIRUMALA IIT & MEDICAL ACADEMY",
    smsHeader: "",
    PE: "1201164330565400925",
    about_us:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_about_us.html",
    terms_and_conditions:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_terms_and_conditions.html",
    privacy_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_privacy_policy.html",
    contact_address:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_contact_address.html",
    cancellation_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_cancellation_policy.html",
    regStart:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/banners/tirumala_01.jpg",
  },
  "5ee85fc60f25a93146ea0bg9": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/sriabhida_mini.png",
    admin_url: "https://sriabhidaattapuradmin.onesaz.com",
    title: "SRI ABHIDA JUNIOR COLLEGE",
    smsHeader: "SRI",
    PE: "1201164330565400925",
    collegeCode: "58538",
    address:
      "58538-SRI ABHIDA JUNIOR COLLEGE,H.NO. 4-6-69/5/A,B,C,D,E, P.No. 104, 105, 106, 109, 110, , Near Pillar No. 141, VASUDEVA REDDY NAGAR COLONY, ATTAPUR",
    rcNo: "Rc.No. 20251/47254/C15-3/2007-2008",
  },
  "5ee85fc60f25a93146ea0bg1": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/pinegrove_mini.png",
    admin_url: "https://pinegroveadmin.onesaz.com",
    title: "PINEGROVE JUNIOR COLLEGE",
    smsHeader: "PINEGROVE",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0a4h": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/vijna_mini.png",
    admin_url: "https://vijnaadmin.onesaz.com",
    new_url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/vijna_new_logo.jpg",
    title: "VIJNA NEET COLLEGE",
    smsHeader: "VIJNA",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0n4o": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/neutrinoacademy_mini.png",
    admin_url: "https://neutrinoadmin.onesaz.com",
    title: "Neutrino Academy",
    smsHeader: "NEUTRINO",
    PE: "1201164330565400925",
    subTitle: "Balancing all inequalities",
  },
  "5ee85fc60f25a93146ea0ayt": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/ayati_mini.png",
    admin_url: "https://ayatiadmin.onesaz.com",
    title: "Ayati junior college",
    smsHeader: "AYATI",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0s01n": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/sundar_mini.png",
    admin_url: "https://sundaradmin.onesaz.com",
    title: "SUNDAR EDUCATIONAL ACADEMY, KOMPALLY",
    smsHeader: "SUNDAR",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0coz": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/cognizant_mini.png",
    admin_url: "https://cognizantadmin.onesaz.com",
    title: "COGNIZANT Institute of NEET and JEE",
    smsHeader: "COGNIZANT",
    PE: "1201164330565400925",
  },
  "5ee85fc60f25a93146ea0meta": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/metamind_mini.png",
    admin_url: "https://metamindadmin.onesaz.com",
    title: "METAMIND JEE&NEET JR COLLEGE",
    smsHeader: "METAMIND",
    PE: "1201164330565400925",
  },
  "66c430d428cbcc7c97d22a27": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/motion_mini.png",
    admin_url: "https://motionadmin.onesaz.com",
    url_MIYAPUR:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/DEEKSHA_LOGO.jpg",
    title: "MOTION IIT JEE ACADEMY",
    smsHeader: "MOTION",
    PE: "1201164330565400925",
  },
  "66d6f203d1e9e56a0955f6b5": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/kle_mini.png",
    admin_url: "https://kleadmin.onesaz.com",
    title: "K.L.E. SOCIETY's INTEGRATED P.U. COLLEGES",
    smsHeader: "KLE",
    PE: "1201164330565400925",
  },
  "66d7fd5ed38d3afac6db0696": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/excellencia_mini.png",
    url_new:
      "https://onesazexams-new.s3.ap-south-1.amazonaws.com/excellenciabrand.png",
    brand_image1:"https://onesazexams-new.s3.ap-south-1.amazonaws.com/excellenciabrand.png",
    admin_url: "https://excellenciaadmin.onesaz.com",
    title: "EXCELLENCIA JR COLLEGE",
    smsHeader: "EXC",
    PE: "1201164330565400925",
    about_us:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/excellencia_about_us.html",
    terms_and_conditions:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/excellencia_terms_and_conditions.html",
    privacy_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/excellencia_privacy_policy.html",
    contact_address:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/excellencia_contact_address.html",
    cancellation_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/excellencia_cancellation_policy.html",
  },
  "66e2a9114c68e81e10ee021c": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/arastu_mini.png",
    admin_url: "https://arastuadmin.onesaz.com",
    title: "ARASTU JR COLLEGE",
    smsHeader: "ARA",
    PE: "1201164330565400925",
  },
  // "5d679d49c136660a09596d85": {
  //   url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/onesaz_mini.png",
  //   title: "ONESAZ",
  //   regStart:
  //     "https://onesaz-new.s3.ap-south-1.amazonaws.com/banners/tirumala_01.jpg",
  // },
  "68021e7f1dfeabf9a3899a2f": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/UNACADEMY_LOGO.jpg",
    admin_url: "https://unacademyadmin.onesaz.com",
    title: "UNACADEMY",
    smsHeader: "UNACADEMY",
    PE: "1201164330565400925",
  },

  "5d679d49c136660a09596d85": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/onesaz_mini.png",
    admin_url: "https://onesazadmin.onesaz.com",
    url_new:
      "https://onesazexams-new.s3.ap-south-1.amazonaws.com/excellenciabrand.png",
    title: "onesaz",
    smsHeader: "",
    PE: "1201164330565400925",
    title: "Onesaz",
    smsHeader: "",
    PE: "1201164330565400925",
    about_us:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_about_us.html",
    terms_and_conditions:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_terms_and_conditions.html",
    privacy_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_privacy_policy.html",
    contact_address:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_contact_address.html",
    cancellation_policy:
      "https://onesazerpnew.s3.ap-south-1.amazonaws.com/HTML_PAGES/tirumala_cancellation_policy.html",

    regStart:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/banners/tirumala_01.jpg",
  },
  "681886cae249be230ccca9d8": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/sgima_mini.png1",
    admin_url: "https://sgimaadmin.onesaz.com",
    title: "SGIMA",
    smsHeader: "SGIMA",
    PE: "1201164330565400925",
  },
  "6853fbe4e939e5261e55a2e2": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/alvas-org-logo.png",
    title: "ALVAS",
    smsHeader: "ALVAS",
    PE: "1201164330565400925",
  },
  "68551d796a7d063da74979a8": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/KI-LABS.png",
    title: "KL-LABS",
    smsHeader: "KL-LABS",
    PE: "1201164330565400925",
  },
  "6879f912111669af6f48516c": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/PLASMA_LOGO1_mini.png",
    title: "PLASMA",
    smsHeader: "PLASMA",
    PE: "1201164330565400925",
  },
  "689569bef4d6d27469ad18a0": {
    url:
      "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/pragyan_mini.png",
    title: "PRAGYAN",
    smsHeader: "PRAGYA",
    PE: "1201164330565400925",
    logoFileName: "pragyan_mini.png",
  },
  "68c8f4482174da0ddf40bd87": {
    url: "https://onesaz-new.s3.ap-south-1.amazonaws.com/logos/spectrum_mini.png",
    title: "SPECTRUM IIT-NEET ACADEMY",
    smsHeader: "SPECTRUM",
    PE: "1201164330565400925",
    logoFileName: "spectrum_mini.png",
    brand_image1: "https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/spectrum_brand1.jpg"
  },

  "68df6b3bbbc67d21a199ebe5":{
    url: "https://onesazerpnew.s3.ap-south-1.amazonaws.com/logos/rootsglobal_mini.png",
    title: "ROOTS GLOBAL JR COLLEGE",
    smsHeader: "ROOTS",
    PE: "1201164330565400925",
    logoFileName: "rootsglobal_mini.png",

  }
};

export const hostnamesMap = {
  "trinity.onesaz.com": "5fa17e1e5eff2c02d9eb32c1",
  "bhashyam.onesaz.com": "5e7370083d8520a40c4ceaaa",
  "sreducation.onesaz.com": "5e9098aaa218252d49be5a3b",
  "sriabhidakp.onesaz.com": "5ee85fc60f25a93146ea0bf9",
  "miity.onesaz.com": "5ea3572fe301133d0a73e9e0",
  "demo.onesaz.com": "5d4c80481a4a8320de0b9e8b",
  "viitjee.onesaz.com": "5dc1388b22bdc209de6a4d80",
  "vinners.onesaz.com": "5e9b3d6cdbae145f55d1e712",
  "sriabhida.onesaz.com": "5ee85fc60f25a93146ea0bg9",
  "onesaz.com": "5d679d49c136660a09596d85",
  "www.onesaz.com": "5d679d49c136660a09596d85",
  "tirumala.onesaz.com": "5fd25b12ed14200ff702f738",
  "medicon.onesaz.com": "602f25174f379c03fa0f7737",
  "impulse.onesaz.com": "608ea4eea4105bb4fbc94822",
  "sandeepani.onesaz.com": "61db4c3da28e11700a6064ac",
  "aiat.onesaz.com": "61e6489a9b609f2143aab796",
  "valleyoak.onesaz.com": "5e521e0da587c5bcefdb7c90",
  "scjc.onesaz.com": "62b317ab4406d92c11fd4257",
  "pjcmncl.onesaz.com": "5dd2de6fc539670ff56e37fc",
  "agastya.onesaz.com": "61e850055876f313e30ea1de",
  "edify.onesaz.com": "63a943927e91069155cc07da",
  "ligadepatil.onesaz.com": "6422b982a32e9b7c5498b129",
  "turito.onesaz.com": "646634c8a400ecffc1306d0d",
  // localhost:4000
  "localhost:4000": "5e7370083d8520a40c4ceaaa",
  localhost: "5e7370083d8520a40c4ceaaa",
  "ybrant.onesaz.com": "6617918287bfb9f18b6d32a5",
  "sr.onesaz.com": "65772522ee64cfa8dc9851f2",
  "pinegrove.onesaz.com": "5ee85fc60f25a93146ea0bg1",
  "neutrinoacademy.onesaz.com": "5ee85fc60f25a93146ea0n4o",
  "vijna.onesaz.com": "5ee85fc60f25a93146ea0a4h",
  "ayati.onesaz.com": "5ee85fc60f25a93146ea0ayt",
  "sundar.onesaz.com": "5ee85fc60f25a93146ea0s01n",
  "cognizant.onesaz.com": "5ee85fc60f25a93146ea0coz",
  "metamind.onesaz.com": "5ee85fc60f25a93146ea0meta",
  "motion.onesaz.com": "66c430d428cbcc7c97d22a27",
  "excellencia.onesaz.com": "66d7fd5ed38d3afac6db0696",
  "kle.onesaz.com": "66d6f203d1e9e56a0955f6b5",
  "unacademy.onesaz.com": "68021e7f1dfeabf9a3899a2f",
  "sgima.onesaz.com": "681886cae249be230ccca9d8",
  "adhyapak.onesaz.com": "684f99ae9af2c801a6d497ea",
  "alvas.onesaz.com": "6853fbe4e939e5261e55a2e2",
  [tip]: tid,
  "plasma.onesaz.com": "6879f912111669af6f48516c",
  "pragyan.onesaz.com": "689569bef4d6d27469ad18a0",
  "spectrum.onesaz.com": "68c8f4482174da0ddf40bd87",
  "rootsglobal.onesaz.com":"68df6b3bbbc67d21a199ebe5"
};

export const institutesMap = {
  "bhashyamadmin.onesaz.com": "5e7370083d8520a40c4ceaaa",
  "srgroup.onesaz.com": "65772522ee64cfa8dc9851f2",
  "srexpenses.onesaz.com": "6655751f14c7f8079c692091",
  "sradmin.onesaz.com": "5e9098aaa218252d49be5a3b",
  "sriabhidaadmin.onesaz.com": "5ee85fc60f25a93146ea0bf9",
  "sriabhidaattapuradmin.onesaz.com": "5ee85fc60f25a93146ea0bg9",
  "miityadmin.onesaz.com": "5ea3572fe301133d0a73e9e0",
  "viitjeeadmin.onesaz.com": "5dc1388b22bdc209de6a4d80",
  "vinnersadmin.onesaz.com": "5e9b3d6cdbae145f55d1e712",
  "vosadmin.onesaz.com": "645b4332b98a5dc4ce54256d",
  "admin.onesaz.com": "5d679d49c136660a09596d85",
  "tirumalaadmin.onesaz.com": "5fd25b12ed14200ff702f738",
  "mediconadmin.onesaz.com": "602f25174f379c03fa0f7737",
  "impulseadmin.onesaz.com": "608ea4eea4105bb4fbc94822",
  "sandeepaniadmin.onesaz.com": "61db4c3da28e11700a6064ac",
  "aiatadmin.onesaz.com": "61e6489a9b609f2143aab796",
  "valleyoakadmin.onesaz.com": "5e521e0da587c5bcefdb7c90",
  "scjcadmin.onesaz.com": "62b317ab4406d92c11fd4257",
  "pjcmncladmin.onesaz.com": "5dd2de6fc539670ff56e37fc",
  "agastyaadmin.onesaz.com": "61e850055876f313e30ea1de",
  "edifyadmin.onesaz.com": "63a943927e91069155cc07da",
  "lpjcadmin.onesaz.com": "6422b982a32e9b7c5498b129",
  "turitoadmin.onesaz.com": "646634c8a400ecffc1306d0d",
  localhost: "5e7370083d8520a40c4ceaaa",
  "ybrantadmin.onesaz.com": "6617918287bfb9f18b6d32a5",
  "pinegroveadmin.onesaz.com": "5ee85fc60f25a93146ea0bg1",
  "sroldadmin.onesaz.com": "5e9098aaa218252d49be5a3b",
  "neutrinoadmin.onesaz.com": "5ee85fc60f25a93146ea0n4o",
  "vijnaadmin.onesaz.com": "5ee85fc60f25a93146ea0a4h",
  "ayatiadmin.onesaz.com": "5ee85fc60f25a93146ea0ayt",
  "sundaradmin.onesaz.com": "5ee85fc60f25a93146ea0s01n",
  "cognizantadmin.onesaz.com": "5ee85fc60f25a93146ea0coz",
  "metamindadmin.onesaz.com": "5ee85fc60f25a93146ea0meta",
  "motionadmin.onesaz.com": "66c430d428cbcc7c97d22a27",
  "kleadmin.onesaz.com": "66d6f203d1e9e56a0955f6b5",
  "excellenciaadmin.onesaz.com": "66d7fd5ed38d3afac6db0696",
  "arastuadmin.onesaz.com": "66e2a9114c68e81e10ee021c",
  "click4digitaladmin.onesaz.com": "67050a28e6b4c447677a8f81",
  "testingadmin.onesaz.com": "65772522ee64cfa8dc9851f3",
  "unacademyadmin.onesaz.com": "68021e7f1dfeabf9a3899a2f",
  "sgimaadmin.onesaz.com": "681886cae249be230ccca9d8",
  "adhyapakadmin.onesaz.com": "684f99ae9af2c801a6d497ea",
  "alvasadmin.onesaz.com": "6853fbe4e939e5261e55a2e2",
  "plasmaadmin.onesaz.com": "6879f912111669af6f48516c",
  "pragyanadmin.onesaz.com": "689569bef4d6d27469ad18a0",
  "spectrumadmin.onesaz.com": "68c8f4482174da0ddf40bd87",
  "rootsglobaladmin.onesaz.com":"68df6b3bbbc67d21a199ebe5"
};
